var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTaskWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M2.004 49.005V5.755c0-1.651 1.355-2.994 3.02-2.994h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H5.024c-1.665 0-3.02-1.343-3.02-2.995z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.514V4.264C0 2.614 1.354 1.27 3.02 1.27h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H3.02c-1.666 0-3.02-1.343-3.02-2.995z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.294 47.861V3.921L2.626 3.919 2.624 47.86l32.67.001z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.78 8.712H4.356v3.833H21.78V8.712z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M31.363 14.462H4.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.78 26.136H4.356v3.834H21.78v-3.834z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M31.363 31.886H4.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.933 0H11.998c-.846 0-1.523.678-1.523 1.511v2.27c0 .84.684 1.511 1.523 1.511h13.935a1.52 1.52 0 001.523-1.511V1.51A1.52 1.52 0 0025.933 0z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M26.501.107c.048.141.068.29.068.45v2.27c0 .84-.684 1.511-1.53 1.511H11.104c-.203 0-.4-.033-.575-.107.19.624.772 1.074 1.462 1.074h13.935a1.52 1.52 0 001.523-1.51V1.517a1.508 1.508 0 00-.948-1.41z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.05 2.149H13.874a.601.601 0 01-.603-.598c0-.329.27-.598.603-.598h10.183c.332 0 .603.269.603.598a.603.603 0 01-.61.598z",
    fill: "#B0B0B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M37.924 3.459l-.007 44.867a2.187 2.187 0 01-2.2 2.183H2.2C.989 50.509 0 49.529 0 48.326V46.58l31.647.007c1.219 0 2.2-.98 2.2-2.19l.008-43.127h1.868c1.212 0 2.2.98 2.2 2.189z",
    fill: "#291475"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M49.428 16.356l-.55-.42-.557-.426a1.743 1.743 0 00-2.412.322l-2.102 2.728-.091.119-1.587 2.077-.092.12-14.013 18.263-.028.12-.282 1.181-.487 2.008-.487 2.014-.113.455 2.243-1.224.776-.427 2.116-1.154.098-.056h.008l14.366-18.719 1.34-1.734.077-.105 2.102-2.742c.155-.203.254-.434.303-.672a1.696 1.696 0 00-.628-1.728z",
    fill: "#291475"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.215 17.58l-2.101 2.742-.078.105-1.608 2.091-.077.098L30.337 40.88l-.106.063-2.898 1.581-2.236 1.224.6-2.462.761-3.19.029-.118L40.5 19.712l.092-.118 1.586-2.078.092-.119 2.102-2.728a1.736 1.736 0 012.412-.322l1.107.847c.755.573.896 1.636.324 2.385z",
    fill: "#ED1B2E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.215 17.58l-2.546 3.316-3.78-2.987 2.476-3.231a1.736 1.736 0 012.412-.322l1.107.846a1.68 1.68 0 01.331 2.378z",
    fill: "#ED1B2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.114 20.322l-.078.105-1.608 2.091-3.935-2.805.099-.118 1.58-2.071 3.942 2.798z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.458 38.096l3.773 2.847-2.891 1.581-2.243 1.224.593-2.469.768-3.183z",
    fill: "#FFDF8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.69 41.28l1.65 1.244-2.243 1.224.593-2.469z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M47.334 14.775l.557.42c.755.573.903 1.643.324 2.392l-17.878 23.3-.106.056-2.891 1.581-2.243 1.224 22.237-28.973z",
    fill: "#ED1B2E"
  })));
}

export default SvgTaskWide;